import { FeatureEnum } from "@smartrr/shared/entities/AccountPlan";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { createLazyFileRoute } from "@tanstack/react-router";

import { ErrorBoundary } from "@vendor-app/app/_sharedComponents/ErrorBoundary";
import { AdminAnalyticsRoute } from "@vendor-app/app/AdminRoute/AdminAnalyticsRoute/AnalyticsDashboard";
import { AdminAnalyticDashboardsRoute } from "@vendor-app/app/AdminRoute/AdminAnalyticsRoute/AnalyticsDashboards";
import { AuthorizedRoute } from "@vendor-app/app/AdminRoute/components/authorization/AuthorizedRoute";

export const Route = createLazyFileRoute("/admin/advanced-analytics")({
  component: Index,
  errorComponent: ({ error, info }) => <ErrorBoundary error={error} info={info} />,
});

function Index() {
  const { analyticsMultiDashboard } = useSmartrrFlags();
  const DashboardComponent = analyticsMultiDashboard ? AdminAnalyticDashboardsRoute : AdminAnalyticsRoute;
  return AuthorizedRoute(FeatureEnum.LOOKER_ANALYTICS, <DashboardComponent />);
}
